import type {ReactElement} from 'react';
import {createPortal} from 'react-dom';
import {useAppSelector} from '@/hooks';
import {Page} from '@PosterWhiteboard/page/page.class';
import VersionHistoryOverlay from './components/version-history-overlay/version-history-overlay';

export function PosterVersionHistoryOverlay(): ReactElement | null {
  const isVersionHistoryOverlayVisible = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryOverlayActive;
  });
  const pagesData = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap;
  });

  if (!isVersionHistoryOverlayVisible || !pagesData) {
    return null;
  }

  const overlays = [];
  for (const [, page] of Object.entries(pagesData)) {
    const container = Page.getCanvasBackdropForPageId(page.hashedID);
    if (container) {
      overlays.push(createPortal(<VersionHistoryOverlay />, container, page.hashedID));
    }
  }

  return <>{overlays}</>;
}
